<template>
    <div>
         <div class="header-wrapper">
        </div>
        <div class="dashboard-content">
            <b-container>
                <b-row class="mt-3 justify-content-md-center">
                    <b-col md="12" class="c-box schedule-box p-0">
                        <div class="heading">Health and success by Rev George</div>
                        <b-row  class=" mt-5 justify-content-md-center">
                            <b-col md="8" sm="12" class="mb-3">
                                <div class="display-box mb-3">
                                    <iframe width="560" height="315" 
                                        src="https://www.youtube-nocookie.com/embed/KdWx3J8l8jw" 
                                        frameborder="0" 
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                                        allowfullscreen>
                                    </iframe>
                                </div>
                                <div class="switch-btn"><span class="fe-repeat"></span> switch to radio</div>
                            </b-col>

                            <b-col md="8" sm="12">
                                <div class="radio-box mb-3">
                                    <div class="timeline">
                                        <div class="progress"></div>
                                    </div>

                                    <div class="controls">
                                        <div class="play-container">
                                            <div class="toggle-play play"></div>
                                        </div>

                                        <div class="time">
                                            <div class="current">0:00</div>
                                            <div class="divider">/</div>
                                            <div class="length"></div>
                                        </div>

                                        <div class="name">Music Song</div>

                                        <div class="volume-container">
                                            <div class="volume-button">
                                                <div class="fe-volume-2 volume"></div>
                                            </div>
                                            
                                            <div class="volume-slider">
                                                <div class="volume-percentage"></div>
                                            </div>
                                        </div>
                                        
                                    </div>
                                </div>

                                <div class="switch-btn"><span class="fe-repeat"></span> switch to video</div>
                            </b-col>

                            <b-col md="12" sm="12" class="mt-5">
                                <b-row>
                                    <b-col md="3">
                                        <div class="video-thumb-box">
                                            <div>Part 1</div>
                                            <div class="fe-play icon"></div>
                                        </div>
                                    </b-col>
                                    <b-col md="3">
                                        <div class="video-thumb-box">
                                            <div>Part 2</div>
                                            <div class="fe-play icon"></div>
                                        </div>
                                    </b-col>
                                    <b-col md="3">
                                        <div class="video-thumb-box">
                                            <div>Part 3 </div>
                                            <div class="fe-play icon"></div>
                                        </div>
                                    </b-col>
                                    <b-col md="3">
                                        <div class="video-thumb-box">
                                            <div>Part 4</div>
                                            <div class="fe-play icon"></div>
                                        </div>
                                    </b-col>
                                </b-row>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
            </b-container>
        </div>
    </div>
</template>

<script>
    export default {
        data(){
            return {
                audiourl: "https://stream.zenolive.com/88yfrap5z0duv.aac"
            }
        },
        methods: {
            getTimeCodeFromNum(num) {
                let seconds = parseInt(num);
                let minutes = parseInt(seconds / 60);
                seconds -= minutes * 60;
                const hours = parseInt(minutes / 60);
                minutes -= hours * 60;

                if (hours === 0) return `${minutes}:${String(seconds % 60).padStart(2, 0)}`;
                return `${String(hours).padStart(2, 0)}:${minutes}:${String(
                    seconds % 60
                ).padStart(2, 0)}`;
            },
            swapClass(from, to, ele){
                ele.classList.remove(from);
                var cList = []
                for (let index = 0; index < ele.classList.length; index++) {
                    cList.push(ele.classList[index])
                }
                ele.classList.remove(...cList)
                cList.unshift(to);
                ele.classList.add(...cList);
            },
            preparePlayer(){
                const audioPlayer = document.querySelector(".radio-box");
                const audio = new Audio(this.audiourl);
                audio.addEventListener(
                    "loadeddata",
                    () => {
                        let duration = (audio.duration != Infinity)? audio.duration : 0;
                        audioPlayer.querySelector(".time .length").textContent = this.getTimeCodeFromNum(
                            duration
                        );
                        audio.volume = .75;
                    },
                    false
                );

                //click on timeline to skip around
                const timeline = audioPlayer.querySelector(".timeline");
                timeline.addEventListener("click", e => {
                        const timelineWidth = window.getComputedStyle(timeline).width;
                        const timeToSeek = e.offsetX / parseInt(timelineWidth) * audio.duration;
                        audio.currentTime = timeToSeek;
                    }, 
                    false
                );

                //click volume slider to change volume
                const volumeSlider = audioPlayer.querySelector(".controls .volume-slider");
                volumeSlider.addEventListener('click', e => {
                        const sliderWidth = window.getComputedStyle(volumeSlider).width;
                        const newVolume = e.offsetX / parseInt(sliderWidth);
                        audio.volume = newVolume;
                        audioPlayer.querySelector(".controls .volume-percentage").style.width = newVolume * 100 + '%';
                    }, 
                    false
                );

                //check audio percentage and update time accordingly
                setInterval(
                    () => {
                        const progressBar = audioPlayer.querySelector(".progress");
                        progressBar.style.width = audio.currentTime / audio.duration * 100 + "%";
                        audioPlayer.querySelector(".time .current").textContent = this.getTimeCodeFromNum(
                            audio.currentTime
                        );
                    }, 500
                );

                
                //toggle between playing and pausing on button click
                const playBtn = audioPlayer.querySelector(".controls .toggle-play");
                playBtn.addEventListener(
                    "click",
                    () => {
                        if (audio.paused) {
                        playBtn.classList.remove("play");
                        playBtn.classList.add("pause");
                        audio.play();
                        } else {
                        playBtn.classList.remove("pause");
                        playBtn.classList.add("play");
                        audio.pause();
                        }
                    },false
                );

                audioPlayer.querySelector(".volume-button").addEventListener("click", () => {
                    const volumeEl = audioPlayer.querySelector(".volume-container .volume");
                    audio.muted = !audio.muted;
                    if (audio.muted) {
                        this.swapClass("fe-volume-2", "fe-volume-x", volumeEl)
                    } else {
                        this.swapClass("fe-volume-x", "fe-volume-2", volumeEl)
                    }
                });

            },
        },

        mounted(){
            this.preparePlayer()
        },
        created(){

        }
    }
</script>

<style lang="scss" scoped>
    .display-box{
        width: 100%;
        height: 400px;
        background-color: black;
        border-radius: 10px;
        overflow: hidden;
        border: 2px solid orangered;
        iframe{
            width: 100%;
            height: 100%;
        }
    }
    .switch-btn{
        width: 150px;
        height: 40px;
        background-color: orangered;
        text-align: center;
        line-height: 40px;
        color: white;
        border-radius: 25px;
    }

    .video-thumb-box{
        width: 100%;
        height: 150px;
        background-color:red;
        border-radius: 5px;
        color: white;
        padding: 15px;
        position: relative;
        cursor: pointer;
        margin-bottom: 20px;
        .icon{
            position: absolute;
            margin-left: 50%;
            transform: translateX(-50%);
            margin-top: 15px;
            font-size: 40px;
        }
    }

    .radio-box {
        height: 100px;
        width: 100%;
        background: #182c8f;;
        border: 2px solid #182c8f;;
        border-radius: 5px;
        font-family: arial;
        color: white;
        font-size: 0.75em;
        overflow: hidden;   

        display: grid;
        grid-template-rows: 6px auto;
        .timeline {
            background: white;
            width: 100%;
            position: relative;
            cursor: pointer;
            .progress {
            background: coral;
            width: 0%;
            height: 100%;
            transition: 0.25s;
            }
        }
        .controls {
            display: flex;
            justify-content: space-between;
            align-items: stretch;
            padding: 0 20px;

            > * {
            display: flex;
            justify-content: center;
            align-items: center;
            }
        .toggle-play {
            &.play {
                cursor: pointer;
                position: relative;
                left: 0;
                height: 0;
                width: 0;
                border: 7px solid #0000;
                border-left: 13px solid white;
                &:hover {
                transform: scale(1.1);
                }
            }
            &.pause {
                height: 15px;
                width: 20px;
                cursor: pointer;
                position: relative;
                &:before {
                position: absolute;
                top: 0;
                left: 0px;
                background: white;
                content: "";
                height: 15px;
                width: 3px;
                }
                &:after {
                position: absolute;
                top: 0;
                right: 8px;
                background: white;
                content: "";
                height: 15px;
                width: 3px;
                }
                &:hover {
                transform: scale(1.1);
                }
            }
        }
        .time {
        display: flex;
            > * {
                padding: 2px;
            }
        }
        .volume-container {
            cursor: pointer;
            .volume-button {
                height: 26px;
                display: flex;
                align-items: center;
                .volume {
                font-size: 20px;
                }
            }
            position: relative;
            z-index: 2;
            .volume-slider {
                position: absolute;
                left: -3px;
                top: 40px;
                z-index: -1;
                width: 0;
                height: 7px;
                background: white;
                transition: .25s;
                border-radius: 25px;
                .volume-percentage {
                    background: yellow;
                    height: 100%;
                    width: 75%;
                }
            }
            &:hover {
                .volume-slider {
                left: -123px;
                width: 120px;
                }
            }
        }
    }
}

</style>